import React from 'react';

/**
 * "Previous / Next" pagination footer. Replaces the identical block in
 * Rides.js, Users.js, and Payments.js.
 *
 * Props:
 *   page         {number}    current page (1-based)
 *   pages        {number}    total pages
 *   onPageChange {function}  called with the new page number
 */
const Pagination = ({ page, pages, onPageChange }) => {
  if (pages <= 1) return null;

  return (
    <div className="flex items-center justify-between px-6 py-4 border-t">
      <p className="text-sm text-gray-500">
        Showing page {page} of {pages}
      </p>
      <div className="flex space-x-2">
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
          className="btn-secondary disabled:opacity-50"
        >
          Previous
        </button>
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page === pages}
          className="btn-secondary disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
